// import { Category } from '@src/domain/repositories/setting.repo'
import {
  EditCarBrandModal,
  EditCarModelModal,
  EditSfxModal,
  EditPioModal,
  EditCarPartModal,
  EditFactoryModal,
  EditStationModal,
  EditShiftModal
} from './components'

export const headerMap = {
  'car-brand': ['品牌', '狀態', '新增日期'],
  'car-model': ['品牌', '車種', '年式', '狀態', '新增日期'],
  sfx: ['品牌', '車種', '年式', 'SFX NO', '狀態', '修改日期'],
  pio: ['項目名稱', '狀態', '新增日期'],
  'car-part': ['代碼', '描述', '狀態', '新增日期'],
  factory: ['廠區代碼', '廠區描述', '狀態', '新增日期'],
  station: ['廠區', '工位代碼', '工位描述', '狀態', '新增日期'],
  shift: ['廠區', '班別代碼', '班別描述', '狀態', '新增日期']
}

export const fieldOrderMap = {
  'car-brand': ['code', 'status', 'createdAt'],
  'car-model': ['carBrandCode', 'description', 'modelYear', 'status', 'createdAt'],
  sfx: ['carBrand', 'carModel', 'carModelYear', 'sfxNo', 'status', 'updatedAt'],
  pio: ['description', 'status', 'createdAt'],
  'car-part': ['code', 'description', 'status', 'createdAt'],
  factory: ['code', 'description', 'status', 'createdAt'],
  station: ['factoryDescription', 'code', 'description', 'status', 'createdAt'],
  shift: ['factoryDescription', 'code', 'description', 'status', 'createdAt']
}

export const titleMap = {
  'car-brand': '品牌',
  'car-model': '車種',
  sfx: '規格(SFX)',
  pio: '項目(PIO)',
  'car-part': '組裝區域',
  factory: '廠區',
  station: '工位',
  shift: '班別'
}

export const editModalMap = {
  'car-brand': EditCarBrandModal,
  'car-model': EditCarModelModal,
  sfx: EditSfxModal,
  pio: EditPioModal,
  'car-part': EditCarPartModal,
  factory: EditFactoryModal,
  station: EditStationModal,
  shift: EditShiftModal
}
